import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { IPagedResult } from '../../shared/models/paged-result';
import { IMarket } from '../../shared/models/core/market';
import { MarketFilterSet } from '../../shared/models/core/market-filter-set';
import { serialize } from '../../utility/serialize';

type CreateMarketPayload = Omit<IMarket, 'id'> & { isPicking?: boolean };

export const branchApi = createApi({
  reducerPath: 'branchApi',
  baseQuery,
  tagTypes: ['Branches'],
  endpoints: (builder) => ({
    getBranches: builder.query<IPagedResult<IMarket>, MarketFilterSet>({
      query: (filterSet) => ({
        url: `/api/markets?${serialize(filterSet)}`,
        method: 'GET',
      }),
      providesTags: ['Branches'],
    }),
    getBranch: builder.query<IMarket, string>({
      query: (id) => ({
        url: `/api/markets/${id}`,
        method: 'GET',
      }),
      providesTags: (_result, _error, id) => [{ type: 'Branches', id }],
    }),
    addBranch: builder.mutation<IMarket, CreateMarketPayload>({
      query: (values) => ({
        url: `/api/markets`,
        method: 'POST',
        body: values,
      }),
      invalidatesTags: ['Branches'],
    }),
    updateBranch: builder.mutation<IMarket, IMarket>({
      query: (values) => ({
        url: `/api/markets/${values.id}`,
        method: 'PUT',
        body: values,
      }),
      invalidatesTags: (_result, _error, { id }) => [{ type: 'Branches', id }],
    }),
    deleteBranch: builder.mutation<void, string>({
      query: (id) => ({
        url: `/api/markets/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Branches'],
    }),
  }),
});

export const {
  useGetBranchesQuery,
  useLazyGetBranchesQuery,
  useAddBranchMutation,
  useGetBranchQuery,
  useLazyGetBranchQuery,
  useUpdateBranchMutation,
  useDeleteBranchMutation,
} = branchApi;
